<ng-container *ngIf="isLoadingPermissions; else permissionsLoaded">
  <div role="status" aria-label="Loading personal details" aria-busy="true">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
  </div>
</ng-container>
<ng-template #permissionsLoaded>
  <mat-card class="mat-elevation-z0" *appTableAccess="[tableReadAccessObj]">
    <mat-card-title class="header">
      <h2 appLocalizationPopupDirective localizationCode="PersonalDetails">{{ 'PersonalDetails' | translate: {Default: "Personal Details"} }}</h2>
  
      <div class="k-flex-grow"></div>

      <div class="buttons-container">
        <mat-form-field appearance="fill" class="effective-date-form-field">
          <mat-label>
              {{ 'EffectiveDate' | translate: {Default: "Effective Date"} }}
          </mat-label>

          <input matInput [matDatepicker]="effectiveDatePicker" (dateChange)="effectiveDateChange($event)" [(ngModel)]="effectiveDate">
          <span fxLayout="row" matSuffix>
              <mat-datepicker-toggle [for]="effectiveDatePicker"></mat-datepicker-toggle>
          </span>
          <mat-datepicker #effectiveDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-icon 
          setColor 
          [setColorRules]="[
            {
                color: 'primaryColour',
                events: ['hover']
            }
          ]" 
          aria-hidden="false" 
          class="material-icons-outlined k-mr-3" 
          role="button"
          tabindex="0"
          aria-label="View access logs"
          appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openAccessLogsDialog()"
          (keydown.enter)="$event.stopPropagation(); openAccessLogsDialog()"
          (keydown.space)="$event.stopPropagation(); openAccessLogsDialog(); $event.preventDefault()"
        >fingerprint</mat-icon>
        <mat-icon 
          setColor 
          [setColorRules]="[
            {
                color: 'primaryColour',
                events: ['hover']
            }
          ]" 
          aria-hidden="false" 
          class="material-icons-outlined  k-mr-3" 
          role="button"
          tabindex="0"
          aria-label="View history"
          appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openHistoryDialog()"
          (keydown.enter)="$event.stopPropagation(); openHistoryDialog()"
          (keydown.space)="$event.stopPropagation(); openHistoryDialog(); $event.preventDefault()"
        >history</mat-icon>
        <button 
          mat-raised-button 
          setColor="primaryColour" 
          color="primary" 
          [disabled]="formValid === false" 
          appPreventDoubleClick 
          (throttledClick)="getFormData = !getFormData" 
          *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj]">
          {{ 'Save' | translate: {Default: "Save"} }}
        </button>
      </div>
    </mat-card-title>
    <mat-card-content>
      <ng-container *ngIf="isLoading; else loaded">
        <div role="status" aria-label="Loading form" aria-busy="true">
          <ngx-skeleton-loader
            count="5"
            [theme]="{ 
                'height.px': 50
            }"
          ></ngx-skeleton-loader>
        </div>
      </ng-container>
      <ng-template #loaded>
        <app-form-generator 
          [formId]="formId"
          [formData]="formData"
          [emitFormDataTrigger]="getFormData"
          [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
          (emitFormData)="formDataEmitted($event)"
          (emitFormStatus)="formStatusUpdated($event)"
          (emitFormPristine)="formPristineEmitted($event)"
        ></app-form-generator>
      </ng-template>
    </mat-card-content>
  </mat-card>
</ng-template>